module.exports = __webpack_public_path__ + "static/media/12UNCTAD11.62d9ed1b.jpg";